import { getCurrentCashSession } from '@/api/cash_management';
import { useQuery } from '@tanstack/react-query';

export function useGetCurrentCashSession(enabled = true) {
  return useQuery({
    queryKey: ['cash-session-current'],
    queryFn: getCurrentCashSession,
    staleTime: 1000 * 60 * 1,
    enabled,
  });
}
